import React from 'react'
import { baseUrl } from '@fs/zion-config'
import { LogoRootstech } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

import BaseOfferCard from './BaseOfferCard'

export default function RootsTechCard() {
  const { t } = useTranslation()

  return (
    <BaseOfferCard
      data-testid="rootstech-card"
      title={t('apac.nlihp.offers.rootstech-card.heading', 'RootsTech')}
      description={t(
        'apac.nlihp.offers.rootstech-card.subheading',
        'Discover resources from the worlds largest family history conference.'
      )}
      Icon={LogoRootstech}
      to={`${baseUrl}/rootstech/search?f.countryTags=00000191-5d19-dbcd-a9f3-5d9b9de70000&p.index=0`}
      external
      linkName="button: rootstech: click"
    />
  )
}
